<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Rekap Nilai">
            <common-training-header v-if="attendant == ''"/>
            <common-training-header :withUser="true" :user_hash="attendant" v-else />
        </a-page-header>

        <a-row>
            <a-col :span="24">
                <a-card type="inner" size="small" :loading="loading">
                    <a-table class="pcp-table" :dataSource="items.items" :rowKey="(r) => r.material.id" :pagination="false" bordered>
                        <a-table-column key="no" title="No" className="align-center text-small text-left">
                            <template slot-scope="text,record,index">
                                <strong>{{ index +1 }}</strong>
                            </template>
                        </a-table-column>

                        <a-table-column key="material" title="Materi Pelatihan" className="align-center text-small text-left">
                            <template slot-scope="record">
                                <strong>{{ record.material.name }}</strong>
                                <p><small>{{ record.material.description }}</small></p>
                            </template>
                        </a-table-column>

                        <a-table-column :width="250" key="category" title="Kategori" className="align-center text-small text-left">
                            <template slot-scope="record">
                                <strong>{{ record.material.category.name }}</strong>
                                <p><small>{{ record.material.category.description }}</small></p>
                            </template>
                        </a-table-column>

                        <a-table-column :width="250" key="inspirator" title="Inspirator" className="align-center text-small text-left">
                            <template slot-scope="record">
                                <a-row type="flex" :gutter="[8, 8]">
                                    <a-col width="32px">
                                        <a-avatar
                                            :size="32"
                                            :src="record.session.inspirator.photo"
                                            v-if="record.session.inspirator.photo != null"
                                        />
                                        <a-avatar class="avatar" :size="32" shape="circle" v-else>{{ initial(record.session.inspirator.name) }}</a-avatar>
                                    </a-col>
                                    <a-col>
                                        <strong>{{ record.session.inspirator.name }}</strong>
                                        <p><small>{{ record.session.inspirator.email }}</small></p>
                                    </a-col>
                                </a-row>
                            </template>
                        </a-table-column>

                        <a-table-column-group>
                            <template #title class="text-center">Nilai</template>
                            <a-table-column key="resume_score" title="Resume" className="align-center text-small text-center">
                                <template slot-scope="record">
                                    <strong v-if="record.is_published">
                                        <a-badge>
                                            {{ parseFloat(record.scores.RSM.score).toFixed(2) }}
                                        </a-badge>
                                    </strong>
                                    <strong v-else>-</strong>
                                </template>
                            </a-table-column>
                            <a-table-column key="exam_score" title="Ujian" className="align-center text-small text-center">
                                <template slot-scope="record">
                                    <strong v-if="record.is_published">
                                        <a-badge :dot="record.is_remidial">
                                        {{ parseFloat(record.scores.EXM.score).toFixed(2) }}
                                        </a-badge>
                                    </strong>
                                    <strong v-else>-</strong>
                                </template>
                            </a-table-column>
                            <a-table-column key="final_score" title="Total" className="align-center text-small text-center">
                                <template slot-scope="record">
                                    <strong v-if="record.is_published">
                                        <a-badge>
                                            {{ parseFloat(record.scores.score).toFixed(2) }}
                                        </a-badge>
                                    </strong>
                                    <strong v-else>-</strong>
                                </template>
                            </a-table-column>
                        </a-table-column-group>

                        <a-table-column :width="200" key="result" title="Hasil" className="align-center text-small text-center">
                            <template slot-scope="record">
                                <strong v-if="record.is_published">
                                    <a-badge :count="'(' + record.wom.rating + ') ' + record.graduation_status " :number-style="{ backgroundColor: record.wom.hex }" />
                                </strong>
                                <strong v-else>-</strong>
                            </template>
                        </a-table-column>
                    </a-table>
                </a-card>
            </a-col>
        </a-row>

        <a-row style="margin-top: 20px;">
            <a-col :offset="12" :span="12">
                <a-card type="inner" size="small" :loading="loading">
                    <a-table
                        class="pcp-table text-small"
                        :columns="columnsSummary"
                        :data-source="summaries"
                        :pagination="false"
                        rowKey="id"
                        width="100%"
                        bordered>
                    </a-table>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>

<style>
th.column-name,
td.column-name {
    text-align: right !important;
    font-weight: bold;
    font-size: small !important;
}
th.column-resume,
td.column-resume {
    text-align: center !important;
    font-weight: bold;
    font-size: small !important;
}
th.column-exam,
td.column-exam {
    text-align: center !important;
    font-weight: bold;
    font-size: small !important;
}
th#solum,
td#solum {
    font-weight: bold;
}
</style>

<script>

const columnsSummary = [
    {
        key: 'name', title: '', dataIndex: 'name', className: 'column-name',
        customRender: (value, row, index) => {
            const obj = {
                //children: CustomIconTooltip,
                children: value,
                attrs: {},
            };
            if (index === 4) {
                obj.attrs.rowSpan = 2;
            }
            if (index === 5) {
                obj.attrs.rowSpan = 0;
            }
            return obj;
        },
    },  {
        key: 'resume', title: 'Resume', className: 'column-resume', dataIndex: 'resume',
        customRender: (value, row, index) => {
            const obj = {
                children: value,
                attrs: {},
            };
            if (index === 4) {
                obj.attrs.colSpan = 2;
            }
            if (index === 5) {
                obj.attrs.colSpan = 2;
                obj.attrs.style = "background-color: "+row.exam.wom.hex+"";
            }

            return obj;
        },
    }, {
        key: 'exam',
        title: 'Ujian',
        className: 'column-exam',
        dataIndex: 'exam',
        customRender: (value, row, index) => {
            const obj = {
                children: value,
                attrs: {},
            };
            if (index === 4) {
                obj.attrs.colSpan = 0;
            }
            if (index === 5) {
                obj.attrs.colSpan = 0;
            }
            return obj;
        },
    },
]

export default {
    props: {
        attendant: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            columnsSummary,
            loading: false,
            items: [],
        };
    },
    created() {
        this.getItems()
    },
    computed: {
        activeModule() {
            return this.$laravel.active_module
        },
        currentRoute(){
            return this.$laravel.current_route
        },
        summaries() {
            let weight = typeof this.items.weight === 'object' ? this.items.weight : { RSM: 0 , EXM: 0 }
            let s = typeof this.items.summary === 'object' ? this.items.summary : 0

            return [
                {
                    id: 1,
                    name: "Bobot Penilaian",
                    resume: (weight.RSM * 100) + " %" ,
                    exam: (weight.EXM * 100) + " %",
                }, {
                    id: 2,
                    name: "Total Nilai",
                    resume: typeof s === 'object' ? s.total_resume : 0,
                    exam:  typeof s === 'object' ? s.total_exam : 0,
                }, {
                    id: 3,
                    name: "Jumlah Modul",
                    resume: typeof s === 'object' ? s.count : 0,
                    exam: typeof s === 'object' ? s.count : 0,
                }, {
                    id: 4,
                    name: "Rata-rata",
                    resume: typeof s === 'object' ? s.avg_resume : 0,
                    exam: typeof s === 'object' ? s.avg_exam : 0,
                }, {
                    id: 5,
                    name: "Nilai Akhir",
                    resume: typeof s === 'object' ? s.total : "",
                    exam: "",
                }, {
                    id: 6,
                    name: "",
                    resume: typeof s === 'object' ? s.graduation_status : "",
                    exam: s,
                }
            ];
        },
    },
    methods: {
        getItems() {
            this.loading = true;

            let params = new URLSearchParams(window.location.search)
            let hash = params.get('attendant') === null ? this.$laravel.user.hash : params.get('attendant')

            let uri = this.routeUri("api.classical-scores.recap", {
                user_hash: hash
            })
            this.$http
                .get(uri)
                .then(response => {
                  this.items = response.data
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        }
    }
};
</script>
